import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@nexelem/api';

export const productTechnologiesListQueryKey = (variantId: number) => ['product-technologies-list', variantId];

export const useProductTechnologiesList = (variantId: number) => {
  const api = useAPI();

  return useQuery({
    queryKey: productTechnologiesListQueryKey(variantId),
    queryFn: () => api.getBackSpecificationsOfVariantP1({ p1: variantId }),
    enabled: !!variantId,
  });
};
